import { MdrCustomerPanelBaseDataProvider } from './MdrCustomerPanelBaseDataProvider';
import { CompanyData } from '../../../company/types/company-data';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';

export class MdrCustomerPanelGzDataProvider extends MdrCustomerPanelBaseDataProvider {
  public async getMyCompanyData(): Promise<CompanyData> {
    const record = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'MdrCompany',
      method: 'getCompanyForMdrCustomerPanel',
      payload: {},
    });

    if (!record || !record.data) {
      throw new Error('No my company data');
    }

    return record.data;
  }
}
